import { writable } from 'svelte/store';
import { nanoid } from 'nanoid';

export const placeHolderData = [
	{},
	{
		dropoff: 'e.g. Bayroute, One BKC',
		pickup: 'e.g. Hiranandani Gardens, Powai',
	},
	{
		dropoff: 'e.g. Hitec City, Financial District',
		pickup: 'e.g. Vanasthalipuram, Hastinapuram',
	},
	{
		dropoff: 'e.g. Capital Cyberscape (Sector-59)',
		pickup: 'e.g. Rithala',
	},
];

// store list of stops
export const routeStops = writable(
	// {
	// 	heading_text: 'Yes! We are running buses on your route.',
	// 	route_data: [
	// 		{
	// 			route: 'Thane - BKC',
	// 			start_stop: { name: 'Majiwada Bus Stop', time_to_start_stop: '6 mins drive' },
	// 			end_stop: { name: 'Fire Station', time_to_end_stop: '4 mins walk' },
	// 			timings: [
	// 				'06:56 AM - 07:40 AM',
	// 				'07:15 AM - 08:06 AM',
	// 				'07:18 AM - 08:11 AM',
	// 				'07:28 AM - 08:22 AM',
	// 				'07:26 AM - 08:29 AM',
	// 				'07:39 AM - 08:46 AM',
	// 				'07:51 AM - 08:56 AM',
	// 				'07:46 AM - 08:53 AM',
	// 				'08:04 AM - 09:26 AM',
	// 				'08:00 AM - 09:22 AM',
	// 				'08:09 AM - 09:30 AM',
	// 				'08:19 AM - 09:49 AM',
	// 				'08:19 AM - 09:40 AM',
	// 				'08:34 AM - 10:00 AM',
	// 				'09:45 AM - 10:59 AM',
	// 				'10:04 AM - 11:09 AM',
	// 				'10:32 AM - 11:33 AM',
	// 				'11:35 AM - 12:30 PM',
	// 			],
	// 		},
	// 		{
	// 			route: 'Thane - BKC',
	// 			start_stop: { name: 'Balkum Fire Station,Thane', time_to_start_stop: '5 mins drive' },
	// 			end_stop: { name: 'Fire Station', time_to_end_stop: '4 mins walk' },
	// 			timings: [
	// 				'07:24 AM - 08:29 AM',
	// 				'07:43 AM - 08:53 AM',
	// 				'07:57 AM - 09:22 AM',
	// 				'08:06 AM - 09:30 AM',
	// 				'08:16 AM - 09:40 AM',
	// 			],
	// 		},
	// 		{
	// 			route: 'Thane - BKC',
	// 			start_stop: {
	// 				name: 'Tatvadnyan Vidhyapith Bus Stop, Kapurbawdi',
	// 				time_to_start_stop: 'less than a min walk',
	// 			},
	// 			end_stop: { name: 'Fire Station', time_to_end_stop: '4 mins walk' },
	// 			timings: [
	// 				'06:53 AM - 07:40 AM',
	// 				'07:10 AM - 08:06 AM',
	// 				'07:24 AM - 08:24 AM',
	// 				'07:33 AM - 08:33 AM',
	// 				'07:54 AM - 09:10 AM',
	// 				'08:06 AM - 09:22 AM',
	// 				'08:29 AM - 09:57 AM',
	// 				'08:44 AM - 10:12 AM',
	// 				'09:40 AM - 10:59 AM',
	// 				'09:59 AM - 11:09 AM',
	// 				'10:29 AM - 11:33 AM',
	// 				'11:30 AM - 12:30 PM',
	// 			],
	// 		},
	// 		{
	// 			route: 'Thane - BKC',
	// 			start_stop: { name: 'Balkum Fire Station,Thane', time_to_start_stop: '5 mins drive' },
	// 			end_stop: { name: 'BDB Gate 1', time_to_end_stop: '9 mins walk' },
	// 			timings: [
	// 				'07:24 AM - 08:30 AM',
	// 				'07:43 AM - 08:54 AM',
	// 				'07:57 AM - 09:23 AM',
	// 				'08:06 AM - 09:31 AM',
	// 				'08:16 AM - 09:41 AM',
	// 			],
	// 		},
	// 		{
	// 			route: 'Thane - BKC',
	// 			start_stop: { name: 'Kalpavriksha, Dhokali', time_to_start_stop: '7 mins drive' },
	// 			end_stop: { name: 'Fire Station', time_to_end_stop: '4 mins walk' },
	// 			timings: [
	// 				'07:22 AM - 08:29 AM',
	// 				'07:42 AM - 08:53 AM',
	// 				'07:55 AM - 09:22 AM',
	// 				'08:05 AM - 09:30 AM',
	// 				'08:15 AM - 09:40 AM',
	// 			],
	// 		},
	// 	],
	// 	route_info: null,
	// 	button_text: 'Download Cityflo App',
	// } || null
	null
);

export const loading = writable(false);


export const formInFocus = writable(false);

export const activeCity = writable(1);

export const busCountOnSelectedRoute = writable(0);

export const isEditing = writable(false)

export const dropOffFieldData = writable({
	location:
		// {
		// 	place_id: 'ChIJG-qGC9_I5zsRlvK9G0vqfs4',
		// 	main_text: 'Bandra Kurla Complex, Bandra East',
		// 	secondary_text: 'Mumbai, Maharashtra, India',
		// 	place_types: ['0', '0', '0', '0'],
		// 	order: 1,
		// 	description: 'Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra, India',
		// } || null,
		null,
	// placesDetails: { lat: 19.0687893, lng: 72.87026469999999 } || null, // stores the selected place  ( {lat:string, lan:string})
	placesDetails: null, // stores the selected place  ( {lat:string, lan:string})
	placeholder: placeHolderData[1].dropoff,
	selectBoxOptions: [],
	sessionToken: nanoid(), // using for google geolocation API
	value: '',
});

export const pickUpFieldData = writable({
	location:
		// 	{
		// 		place_id: 'ChIJ2SZP8Ey55zsRTcZXpMHBL4k',
		// 		main_text: 'Majiwada',
		// 		secondary_text: 'Thane, Maharashtra, India',
		// 		place_types: ['sublocality_level_1', 'sublocality', 'political', 'geocode'],
		// 		order: 1,
		// 		description: 'Majiwada, Thane, Maharashtra, India',
		// 	} || null,
		null,
	// placesDetails: { lat: 19.2136775, lng: 72.9903447 } || null,
	placesDetails: null,
	selectBoxOptions: [],
	sessionToken: nanoid(), // using for google geolocation API
	value: '',
	placeholder: placeHolderData[1].pickup,
});

export const sectionIntroDelay = 500;
